import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { Image as ImageIcon } from "lucide-react";
import type { ContractResponseDTO } from "../types/contract.types";
import { memo } from "react";

/**
 * Dialog para visualização da imagem anexada a um contrato.
 *
 * Em caso de falha no carregamento da imagem, exibe um SVG inline como fallback
 * para evitar o ícone de imagem quebrada do browser.
 */
interface ContractImageDialogProps {
  open: boolean;
  contract: ContractResponseDTO | null;
  onClose: () => void;
}

export const ContractImageDialog = memo(function ContractImageDialog({
  open,
  contract,
  onClose,
}: ContractImageDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Imagem do Contrato</DialogTitle>
          <DialogDescription>
            {contract?.contractNumber} — {contract?.clientName}
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          {contract?.contractImageUrl ? (
            <img
              src={contract.contractImageUrl}
              alt={`Contrato ${contract.contractNumber}`}
              className="w-full h-auto max-h-[70vh] object-contain rounded-md"
              onError={(e) => {
                (e.target as HTMLImageElement).src =
                  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%23f0f0f0" width="400" height="300"/%3E%3Ctext fill="%23999" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3EImagem não disponível%3C/text%3E%3C/svg%3E';
              }}
            />
          ) : (
            <div className="flex items-center justify-center h-64 bg-muted rounded-md">
              <div className="text-center text-muted-foreground">
                <ImageIcon className="w-16 h-16 mx-auto mb-2" />
                <p>Nenhuma imagem disponível</p>
              </div>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});
